import { faker } from '@faker-js/faker';


/**
 * Create contacts for the address book and sort them.
 * @param {number} count - The number of contacts to create.
 * @returns {Array} - Sorted array of contacts.
 */
export function createContacts(count) {
    let contacts = [];
    let i = 0;
    while (i < count) {
        contacts.push({
            'id': faker.number.int({ min: 0, max: 99999 }),
            'type': contactType(),   // Generates a random contact type
            'name': faker.company.name(),
            'companyName': faker.company.name(),
            'website': faker.internet.url(),
            'number': faker.phone.number(),
            'email': faker.internet.email(),
            'address': createAddress(),
            'jobTitle': faker.person.jobTitle(),
            'description': faker.lorem.sentence(5),
            'isBookable': randomBool(),
            'isVat': randomBool(),
            'image': faker.image.urlLoremFlickr(),
            'default': i === 0  // Set 'default' to true if id is 0, otherwise false


        });

        i++; // Increment the count
    }

    // Sort contacts by 'name' by default
    return sortItemsByField(contacts);
}


/**
 * Sort an array of objects alphabetically based on a specified field.
 * @param {Array} items - Array of objects to sort.
 * @param {string} field - The field to sort by (default is 'name').
 * @returns {Array} - Sorted array of objects.
 */
export function sortItemsByField(items, field = 'name') {
    return items.sort((a, b) => a[field].localeCompare(b[field]));
}

// Create services
export function createServices(count) {
    let services = [];
    let i = 0;
    while (i < count) {
        services.push({
            'id': faker.number.int({ min: 1001, max: 9999 }),
            'contactType': contactType(),   // Generates a random contact type
            'name': faker.company.name(),
            'type': createServiceType(),
            'description': faker.lorem.sentence(5),
            'contact': createContacts(3)
        });

        i++; // Increment the count
    }
    return sortItemsByField(services);

}


// Create Single contact for the address book
export function createContact() {
    let contact = {
        'id': faker.number.int({ min: 1001, max: 9999 }),
        'image': faker.image.urlLoremFlickr(),
        'companyName': faker.company.name(),
        'name': faker.company.name(),
        'address': createAddress(),
        'jobTitle': faker.person.jobTitle(),
        'number': faker.phone.number(),
        'email': faker.internet.email(),
        'description': faker.lorem.sentence(5),
        'isBookable': randomBool(),
        'isVat': randomBool(),

    };

    return contact;
}



// Function to create a random Bool
function randomBool() {
    let types = [true, false];
    let length = types.length;
    return types[randomNumber(length)];
}
//create an Address object
function createAddress() {
    return {
        'address1': faker.location.streetAddress(false),
        'address2': faker.location.secondaryAddress(),
        'town': faker.location.city(),
        'county': faker.location.state(),
        'country': 'UK',
        'postcode': 'W6 9QH',
    }
}

// Create Companies for the address book
export function createCompanies(count) {
    let company = [];
    let i = 0;
    while (i < count) {
        company.push({
            'id': i,
            'type': companyType(),   // Generates a random contact type
            'companyName': faker.company.name(),
            'address': createAddress(),
            'website': faker.internet.url(),
            'accountNumber': faker.number.int({ min: 1001, max: 9999 }),
            'vatNumber': faker.number.int({ min: 1001, max: 9999 }),
            'companyReg': faker.number.int({ min: 1001, max: 9999 }),
            'status': companyStatus(),
            'image': faker.image.urlLoremFlickr(),
            'number': faker.phone.number(),
            'email': faker.internet.email(),
            'staff': createContacts(5),
            'description': faker.lorem.sentence(5),


        });

        i++; // Increment the count
    }
    return sortItemsByField(company, 'companyName');

}


// Create Companies for the address book
export function createInternalStaff(count) {
    let internal = [];
    let i = 0;
    while (i < count) {
        internal.push({
            'id': faker.number.int({ min: 0, max: 99999 }),
            'name': faker.company.name(),
            'number': faker.phone.number(),
            'email': faker.internet.email(),
            'department': randomDepartment(),
            'jobTitle': faker.person.jobTitle(),
            'image': faker.image.urlLoremFlickr(),
            'position': randomCategory(),
            'extension': faker.number.int({ min: 100, max: 999 }),
            'notes': faker.lorem.sentence(5),
            'employmentType': createEmployemntType()

        });

        i++; // Increment the count
    }
    return sortItemsByField(internal);

}


// Create Companies for the address book
export function createFreelancers(count) {
    let freelancer = [];
    let i = 0;
    while (i < count) {
        freelancer.push({
            'id': faker.number.int({ min: 0, max: 99999 }),
            'name': faker.company.name(),
            'company': faker.company.name(),
            'number': faker.phone.number(),
            'email': faker.internet.email(),
            'website': faker.internet.url(),
            'address': createAddress(),
            'image': faker.image.urlLoremFlickr(),
            'skills': FreelanceSkills(3),
            'rating': faker.number.int({ min: 0, max: 5 }),
            'notes': faker.lorem.sentence(5),
            'upcomingJobs': createProjects(3),
            'documents': createFreeLanceDocuments(4),
            'roles': getRandomCrewTypes(),
            'isBookable': randomBool(),
            'isVat': randomBool(),
            'projects': createProjects(5), //number of jobs booked and completed



        });

        i++; // Increment the count
    }

    return sortItemsByField(freelancer);

}



// ***************************************** Create Projects
export function createProjects(count) {
    let projects = [];
    let i = 0;
    while (i < count) {
        const startDate = futureDate();
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + faker.number.int({ min: 1, max: 14 })); // End date 1-14 days after start

        projects.push({
            id: i,
            'projectNumber': `PRJ${faker.number.int({ min: 1001, max: 9999 })}`,
            'name': faker.commerce.productName(),
            'client': faker.company.name(),
            'start': startDate,
            'end': endDate,
            'time': futureTime(),
            'status': projectType(),
            'projectManager': faker.person.fullName(),
            'type': getProjectType(), //Only used for the intoday and outToday types
            'shortages': faker.number.int({ min: 0, max: 1000 }),
            'confirmedSubs': faker.number.int({ min: 0, max: 10 }),
            'unconfirmedSubs': faker.number.int({ min: -100, max: 10 }),
            'itemsCount': faker.number.int({ min: 50, max: 500 }),
            'totalItems': faker.number.int({ min: 50, max: 500 }),
            'totalPrepped': faker.number.int({ min: 0, max: 500 }),
            'itemsPrepared': faker.number.int({ min: 0, max: 500 }),
            'projectName': faker.commerce.productName(), // Some components might use this instead of name
        });

        i++;
    }
    return projects;
}

// ***************************************** Create Tests
export function createTests(count) {
    let tests = [];
    let i = 0;
    while (i < count) {



        tests.push({
            id: i,
            'barcode': faker.number.int({ min: 1001, max: 9999 }),
            'assetName': faker.commerce.productName(),
            'dueDate': futureDate(),
            'overdue': faker.number.int({ min: 0, max: 100 }),
            'thisMonth': faker.number.int({ min: 0, max: 100 }),
            'nextMonth': faker.number.int({ min: -0, max: 100 }),
        });

        i++;
    }
    return tests;
}


// ************************************************** Create Assets
export function createAssets(count) {
    const stockType = getStockType()
    let assets = [];
    let i = 0;
    while (i < count) {
        assets.push({
            'id': i,
            'name': faker.commerce.productName().trim(),
            'totalQty': faker.number.int({ min: 0, max: 500 }),
            'availableQty': faker.number.int({ min: 0, max: 500 }),
            'rate': faker.number.int({ min: 0, max: 500 }),
            'image': faker.image.urlLoremFlickr(),

        });

        if (stockType === 'serial') {
            assets.push({
                'stock': createStock(1000)
            })
        }


        i++;
    }
    return assets;
}

// ************************************************** Create a single Asset as an object
export function createAsset() {
    const stockType = getStockType()
    let asset = {
        'id': faker.number.int({ min: 0, max: 9999 }),
        'masterAsset': createMasterAssets(1),
        'image': faker.image.urlLoremFlickr(),
        'category': randomCategory(),
        'masterCategory': randomDepartment(),
        'department': randomDepartment(),
        'totalQty': faker.number.int({ min: 0, max: 500 }),
        'availableQty': faker.number.int({ min: 0, max: 500 }),
        'rate': faker.number.int({ min: 0, max: 500 }),
        'rateType': rateType(),
        'replacementValue': faker.number.int({ min: 100, max: 50000 }),
        'stockType': stockType,
        'origin': 'UK'
    };
    return asset;
}

/********************************************* CREATE MASTER ASSETS */
export function createMasterAssets(count) {
    let masterAssets = [];
    let i = 0;
    while (i < count) {
        masterAssets.push({
            'id': i,
            'name': faker.commerce.productName(),
            'image': faker.image.urlLoremFlickr(),
            'length': faker.number.int(100),
            'width': faker.number.int(100),
            'height': faker.number.int(100),
            'weight': faker.number.int(100),
        });

        i++;
    }
    return masterAssets;
}


// ********************************************* Create purchase Orders
export function createPurchaseOrders(count) {
    let purchaseOrders = [];
    let i = 0;
    while (i < count) {
        purchaseOrders.push({

            'orderNumber': faker.finance.accountNumber({ length: 5 }), // 32564
            'summary': faker.lorem.sentence(5),
            'project': faker.commerce.productName(),
            'client': faker.company.name(),
            'issueDate': futureDate(),
            'total': faker.commerce.price(),
            'status': purchaseOrderStatus(),
            'issuedBy': faker.person.fullName(),

        });

        i++;
    }
    return purchaseOrders;
}


/********************************************* CREATE PROJECT ASSETS */
export function createProjectAssets(count) {
    let pAssets = [];
    let i = 0;
    while (i < count) {
        const assetId = i;
        const hasAccessories = faker.datatype.boolean(); // Randomly decide if this asset should have accessories
        const accessories = hasAccessories ? createAccessories(faker.number.int({ min: 1, max: 3 })) : []; // 1-3 accessories if hasAccessories is true
        const group = createProjectGroups(); // Create group once for both asset and its accessories

        accessories.forEach(acc => {
            acc.parentAssetId = assetId;
            acc.group = group; // Add group to accessories
        });

        // Add the main asset
        pAssets.push({
            'id': assetId,
            'name': faker.commerce.productName(),
            'cost': faker.number.int({ min: 0, max: 100 }),
            'price': faker.number.int({ min: 0, max: 100 }),
            'rateType': rateType(),
            'days': faker.number.int({ min: 0, max: 100 }),
            'discount': faker.number.int({ min: 0, max: 100 }),
            'qty': faker.number.int({ min: 0, max: 100 }),
            'type': 'asset',
            'group': group,
            'status': createProjectAssetStatus(), //none, prepped, dispatched, returned, dep-prepped
            'image': faker.image.urlLoremFlickr({ category: 'technics' }),
            'location': {
                'warehouse': faker.helpers.arrayElement(['Main Warehouse', 'Studio Warehouse', 'Offsite Storage']),
                'aisle': faker.helpers.arrayElement(['A', 'B', 'C', 'D', 'E']),
                'shelf': faker.number.int({ min: 1, max: 10 }).toString(),
                'bin': faker.number.int({ min: 1, max: 20 }).toString()
            }
        });

        // Add the accessories to the main array if they exist
        if (accessories.length > 0) {
            pAssets.push(...accessories);
        }

        i++;
    }
    return pAssets;
}

/********************************************* CREATE Random skills  */
export function randomSkills(count) {
    let skill = [];
    let i = 0;
    while (i < count) {
        skill.push({
            'skill': randomDepartment(),
            'rating': faker.number.int({ min: 0, max: 5 })
        });

        i++;
    }
    return skill;
}


/********************************************* CREATE Random skills  */
export function FreelanceSkills(count) {
    let skill = [];
    let i = 0;
    while (i < count) {
        skill.push({
            'skill': createFreelanceSkill(),
            'rating': faker.number.int({ min: 0, max: 5 }),
            'expiry': futureDate(),
            'hasDownload': randomBool(),

        });

        i++;
    }
    return skill;
}



// ********************************************* Create INVOICES
export function createInvoices(count) {
    let invoices = [];
    let i = 0;
    while (i < count) {
        invoices.push({

            'invoiceNumber': faker.finance.accountNumber({ length: 5 }), // 32564
            'invoiceDate': futureDate(),
            'dueDate': futureDate(),
            'client': faker.company.name(),
            'total': faker.commerce.price(),
            'status': invoiceStatus(),

        });

        i++;
    }
    return invoices;
}

// ********************************************* Create VEHICLES
export function createVehicles(count) {
    let vehicles = [];
    let i = 0;
    while (i < count) {
        vehicles.push({

            'type': vehicleType(),
            'colour': faker.vehicle.color(),
            'manufacturer': faker.vehicle.manufacturer(),
            'model': faker.vehicle.model(),
            'registration': faker.vehicle.vrm(),
            'location': faker.finance.accountNumber({ length: 5 }),
            'status': vehicleStatus(),
            'mot': futureDate(),

        });

        i++;
    }
    return vehicles;
}

// ********************************************* Create Transport Runs
export function createTransport(count) {
    let transport = [];
    let i = 0;
    while (i < count) {
        transport.push({
            'name': faker.commerce.productName(),
            'vehicleType': vehicleType(),
            'transportType': transportPurpose(),
            'startTime': futureDate(),
            'endTime': futureDate(),
            'postcode': faker.location.zipCode(),
            'assignedReg': faker.vehicle.vrm(),
            'status': transportStatus(),
            'projectManager': faker.person.fullName(),


        });

        i++;
    }
    return transport;
}

// ********************************************* Create Crewing
export function createCrewing(count) {
    let crewing = [];
    let i = 0;
    while (i < count) {
        crewing.push({
            'id': i + 1,
            'projectName': faker.commerce.productName(),
            'startDate': futureDate(),
            'client': faker.company.name(),
            'projectManager': faker.person.fullName(),
            'status': crewStatus(),
            'notAllocated': faker.number.int({ min: 0, max: 10 }),
            'awaitingConfirmation': faker.number.int({ min: 0, max: 8 }),
            'confirmed': faker.number.int({ min: 0, max: 15 })
        });

        i++;
    }
    return crewing;
}

// ********************************************* Create Crew Types
export function createCrewTypes() {

    return [
        {
            role: 'Lighting Engineer',
            rate: 250,
            cost: 200,
            rating: faker.number.int({ min: 0, max: 5 })

        },
        {
            role: 'Sound Engineer',
            rate: 250,
            cost: 200,
            rating: faker.number.int({ min: 0, max: 5 })

        },
        {
            role: 'Video Engineer',
            rate: 250,
            cost: 200,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Lighting Designer',
            rate: 350,
            cost: 300,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Lighting Operator',
            rate: 450,
            cost: 400,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Rigger',
            rate: 350,
            cost: 300,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Sound Operator',
            rate: 250,
            cost: 200,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Crew Chief ',
            rate: 350,
            cost: 300,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Local Crew',
            rate: 150,
            cost: 100,
            rating: faker.number.int({ min: 0, max: 5 })

        }, {
            role: 'Project Manager',
            rate: 550,
            cost: 500,
            rating: faker.number.int({ min: 0, max: 5 })

        }]


}

// Function to get 5 random crew types used in the freelancer job role function
export function getRandomCrewTypes() {
    const crewTypes = createCrewTypes();

    // Shuffle the array
    const shuffled = crewTypes.sort(() => 0.5 - Math.random());

    // Get 5 random elements
    const randomCrewTypes = shuffled.slice(0, 5);

    return randomCrewTypes;
}

// ********************************************* Create Random Chats
export function createChats(count) {
    let chats = [];
    let i = 0;
    while (i < count) {
        chats.push({
            'id': i,
            'project': faker.commerce.productName(),
            'summary': faker.lorem.sentence(5),
            'conversation': createConversation(randomNumber(100))
        });

        i++;
    }
    return chats;
}


// ********************************************* Create Random Conversations
export function createConversation(count) {
    let conversation = [];
    let i = 0;
    while (i < count) {
        conversation.push({
            'id': i,
            'person': getPerson(),
            'message': faker.lorem.sentence(5),
        });

        i++;
    }
    return conversation;
}



// ********************************************* Create Random Returns
export function createReturns(count) {
    let returns = [];
    let i = 0;
    while (i < count) {
        returns.push({
            'id': i,
            'barcode': faker.finance.accountNumber({ length: 4 }),
            'assetName': faker.commerce.productName(),
            'project': faker.commerce.productName(),
            'returnDate': futureDate(),
            'returnTime': getCurrentTime(),
            'returnPerson': faker.person.fullName(),

        });

        i++;
    }
    return returns;
}

// ********************************************* Create Random Repairs
export function createRepairs(count) {
    let returns = [];
    let i = 0;
    while (i < count) {
        returns.push({
            'id': i,
            'barcode': faker.finance.accountNumber({ length: 4 }),
            'assetName': faker.commerce.productName(),
            'fault': faker.lorem.sentence(5),
            'logDate': futureDate(),
            'logPerson': faker.person.fullName(),

        });

        i++;
    }
    return returns;
}

// ********************************************* Create Random Repairs
export function createFreeLanceDocuments(count) {
    let returns = [];
    let i = 0;
    while (i < count) {
        returns.push({
            'id': i,
            'name': createFreelanceDocument(),
            'expiry': futureDate(),


        });

        i++;
    }
    return returns;
}

// ********************************************* Create Random Cases
export function createCases(count) {
    let cases = [];
    let i = 0;
    while (i < count) {
        cases.push({
            'id': i,
            'caseName': faker.commerce.productName(),
            'caseType': caseType()
        });

        i++;
    }
    return cases;
}

/********************************************* CREATE STOCK LEVELS */
export function createStock(count) {
    let stock = [];
    let i = 0;
    while (i < count) {
        stock.push({
            'id': i,
            'barcode': i + 1001,
            'rfid': faker.number.int({ min: 1001, max: 9999 }),
            'qrCode': faker.number.int({ min: 1001, max: 9999 }),
            'serial': faker.number.int({ min: 1001, max: 9999 }),
            'status': getStockStatus(),
            'notes': faker.lorem.sentence(10),
            'isDelete': false

        });

        i++;
    }
    return stock;
}

// ********************************************* Create Accessories
export function createAccessories(count) {
    let acc = [];
    let i = 0;
    while (i < count) {
        acc.push({
            'id': i,
            'qty': faker.number.int({ min: 1, max: 20 }),
            'assetID': faker.finance.accountNumber({ length: 4 }),
            'name': faker.commerce.productName(),
            'type': 'accessory',
            'cost': faker.number.int({ min: 1, max: 20 }),
            'status': 'none',
            'image': faker.image.urlLoremFlickr({ category: 'technics' }),
            'location': {
                'warehouse': faker.helpers.arrayElement(['Main Warehouse', 'Studio Warehouse', 'Offsite Storage']),
                'aisle': faker.helpers.arrayElement(['A', 'B', 'C', 'D', 'E']),
                'shelf': faker.number.int({ min: 1, max: 10 }).toString(),
                'bin': faker.number.int({ min: 1, max: 20 }).toString()
            }
        });

        i++;
    }
    return acc;
}

// ********************************************* Create Venue Type
export function createVenues(count) {
    let venue = [];
    let i = 0;
    while (i < count) {
        venue.push({
            'id': i,
            'name': faker.commerce.productName(),
            'type': venueType(),
            'location': faker.location.city(),
            'address': createAddress(),
            'isBookable': randomBool(),
            'staff': createContacts(5),
            'description': faker.lorem.sentence(15),



        });

        i++;
    }
    return sortItemsByField(venue);

}


/********************************************* CREATE COSTS */
export function createCosts(count) {
    let masterAssets = [];
    let i = 0;
    while (i < count) {
        masterAssets.push({
            'id': i,
            'supplierName': faker.commerce.productName(),
            'cost': faker.number.int({ min: 10, max: 100 }),
            'rateType': rateType(),
        });

        i++;
    }
    return masterAssets;
}


/********************************************* CREATE RAMS */
export function riskAssessments(count) {
    let rams = [];
    let i = 0;
    while (i < count) {
        rams.push({
            'id': i,
            'name': faker.commerce.productName(),
            'description': faker.lorem.sentence(5),
            'risk': faker.number.int({ min: 1, max: 10 }),
            'severity': faker.number.int({ min: 1, max: 10 }),
        });

        i++;
    }
    return rams;
}

/********************************************* CREATE TESTS */
export function getTests(count) {
    let test = [];
    let i = 0;
    while (i < count) {
        test.push({
            'id': i,
            'name': faker.commerce.productName(),
            'type': testType(),
            'due': futureDate(),
        });

        i++;
    }
    return test;
}


function getCurrentTime() {
    const now = new Date();

    // Get the current hours, minutes, and seconds
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currentTime = `${hours}:${minutes}:${seconds}`;
    return currentTime

}

// Function to get a random case type
function caseType() {
    let types = ['temporary', 'permanent'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to create freelance documents
function createFreelanceDocument() {
    let doc = ['PLI Insurance', 'Ipaf', 'CounterBalance FLT', 'NRC Level2', 'IRATA', 'PASMA'];
    let length = doc.length;
    return doc[randomNumber(length)];
}


// Function to create a random employment type
function createEmployemntType() {
    let type = ['Full Time', 'Part Time', 'Casual', 'Temporary'];
    let length = type.length;
    return type[randomNumber(length)];
}

// Function to create the status of a company
function companyStatus() {
    let status = ['Ok', 'On Hold', 'Cash Only', 'Payment Up Front'];
    let length = status.length;
    return status[randomNumber(length)];
}

// Function to get a random department.
// We need to limit the length of these skills
function createFreelanceSkill() {
    let skill = ['GrandMa3', 'GrandMa2', 'BS7909', 'Avolites', 'NRC L2', 'NRC L3', 'PASMA', 'IPAF', 'BS7909', 'Hog 4', 'Luminex'];
    let length = skill.length;
    return skill[randomNumber(length)];
}


// Function to get a random department
function randomDepartment() {
    let types = ['Lighting', 'Sound', 'Video', 'Rigging', 'Staging', 'Set'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get random people to form a conversation
function getProjectType() {
    let types = ['project delivery', 'project collection', 'customer collection', 'customer delivery', 'sub-hire collection', 'sub-hire delievery', 'other'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get a random status for project assets such as prepped, dispatched
function createProjectAssetStatus() {
    let types = ['none', 'prepared', 'dispatched', 'returned', 'deprepped'];
    let length = types.length;
    return types[randomNumber(length)];
}
// Function to get random stock status
function getStockStatus() {
    let types = ['available', 'unavailable', 'workshop'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get random people to form a conversation
function getPerson() {
    let types = ['person1', 'person2', 'person3', 'person4', 'me'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random crew Status
function crewStatus() {
    let types = ['not booked', 'confirmed', 'waiting'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get a random transport purpose
function transportPurpose() {
    let types = ['delivery', 'collection'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get a random transport status
function transportStatus() {
    let types = ['waiting', 'in progress', 'complete'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get a random service type
function createServiceType() {
    let types = ['Transport', 'IT', 'Waste Management', 'Couriour', 'Cleaning'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get a random vehicle status
function vehicleStatus() {
    let types = ['available', 'busy', 'offroad'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random vehicle type
function vehicleType() {
    let types = ['car', '3.5ton van', '3.5ton Luton', '7.5ton', '18ton', 'artic'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random contact type
function projectType() {
    let types = ['confirmed', 'draft', 'quote'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random contact type
function contactType() {
    let types = ['Company', 'Venue', 'Internal Staff', 'Freelancer'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random contact type
function venueType() {
    let types = ['Studio', 'Rehersal Space', 'Concert Hall', 'Academey', 'club', 'theatre', 'other'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a purchase order status
function purchaseOrderStatus() {
    let types = ['draft', 'confirmed'];
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random invoice Status 
function invoiceStatus() {
    let types = ['draft', 'sent', 'paid', 'overdue'];
    let length = types.length;
    return types[randomNumber(length)];
}

function randomNumber(length) {
    return Math.floor(Math.random() * length);
}   // Generate a random index between 0 and length-1

function futureDate() {
    // Generate a future date (e.g., within the next year)
    const futureDate = faker.date.future(); // By default, generates a date within the next year

    // Format the date as dd/mm/yyyy
    return futureDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

function futureTime() {
    // Generate a future date (e.g., within the next year)
    const futureTime = faker.date.future();

    // Format the time as hh:mm
    return futureTime.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
    });
}

// Function to get a random category
function randomCategory() {
    let types = ['moving lights', 'led', 'hoists', 'networking', 'speakers', 'amplifiers', 'projectors', 'cable', 'data cable', 'dmx', 'xlr', 'generics', 'control'];
    let length = types.length;
    return types[randomNumber(length)];
}


export function createTags(count) {
    let tags = [];
    let i = 0;
    while (i < count) {
        tags.push({
            'id': i,
            'tag': randomCategory()

        });

        i++;
    }
    return tags;
}

// Function to get a random rate Type
function rateType() {
    let types = ['rate1', 'rate2', 'rate3', 'rate4', 'rate5']
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random Stock type
function getStockType() {
    let types = ['bulk', 'serial',]
    let length = types.length;
    return types[randomNumber(length)];
}

// Function to get a random transport status
function testType() {
    let types = ['loler', 'pat', 'functional'];
    let length = types.length;
    return types[randomNumber(length)];
}


// Function to get a random Company Type
function companyType() {
    let types = ['Supplier', 'Client', 'Both'];
    let length = types.length;
    return types[randomNumber(length)];
}

function createProjectGroups() {
    let groups = ['Group 1', 'Group 2', 'Group 3', 'Group 4', 'Group 5', 'Group 6', 'Group 7', 'Group 8', 'Group 9', 'Group 10'];
    let cols = ['white', 'red', 'orange', 'yellow', 'blue', 'purple', 'green', 'brown', 'black', 'grey']
    let gLen = groups.length;
    let cLen = cols.length;

    let returnedGroups = {
        'name': groups[randomNumber(gLen)],
        'col1': cols[randomNumber(cLen)],
        'col2': cols[randomNumber(cLen)]
    }
    return returnedGroups
}
//Create a fake return item
export function fakeReturn(returnLength, barcode) {
    let date = new Date(); // Current date and time
    let returns = {
        id: returnLength + 1,
        barcode: barcode,
        assetName: faker.commerce.productName(),
        project: faker.commerce.productName(),
        returnDate: formatDate(date),
        returnTime: formatTime(date),
        returnPerson: faker.person.fullName(),
    }
    return returns;

}


function formatDate(date) {
    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    let year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    return `${day}/${month}/${year}`;
}

function formatTime(date) {
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
}


export function createTodayProjects(count = 100) {
    const jobTypes = [
        'Customer Collection',
        'Truck Load',
        'Truck Unload',
        'Customer Returning Truck Load',
    ];

    const projects = [];

    for (let i = 0; i < count; i++) {
        const startDate = faker.date.between({
            from: '2023-12-01',
            to: '2023-12-10',
        }); // Updated for new API
        const endDate = faker.date.soon({
            days: 2,
            refDate: startDate,
        }); // Updated for new API
        const status = faker.helpers.arrayElement(['confirmed', 'pending', 'cancelled']);
        const type = faker.helpers.arrayElement(jobTypes);

        projects.push({
            id: faker.string.uuid(), // Updated API for UUID
            name: faker.commerce.productName(),
            start: startDate.toISOString().split('T')[0], // Format as YYYY-MM-DD
            end: endDate.toISOString().split('T')[0],
            status,
            customer: faker.person.fullName(), // Updated API for name
            type,
            items: faker.number.int({ min: 1, max: 50 }), // Updated API for number
        });
    }

    return projects;
}

// Create Quotes
export function createQuotes(count) {
    let quotes = [];
    let i = 0;
    while (i < count) {
        quotes.push({
            'id': faker.number.int({ min: 0, max: 99999 }),
            'quoteNumber': `Q-${faker.number.int({ min: 10000, max: 99999 })}`,
            'client': faker.company.name(),
            'project': faker.company.catchPhrase(),
            'quoteDate': faker.date.recent().toLocaleDateString(),
            'validUntil': faker.date.future().toLocaleDateString(),
            'status': quoteStatus(),
            'total': faker.number.float({ min: 500, max: 20000, precision: 2 }),
            'createdBy': faker.person.fullName()
        });

        i++; // Increment the count
    }
    return sortItemsByField(quotes, 'quoteNumber');
}

// Quote Status
function quoteStatus() {
    let types = ['draft', 'sent', 'approved', 'rejected'];
    let length = types.length;
    return types[randomNumber(length)];
}

export function createParts(count) {
    let parts = [];
    let i = 0;
    while (i < count) {
        parts.push({
            'partNumber': `P${faker.number.int({ min: 1000, max: 9999 })}`,
            'name': faker.commerce.productName(),
            'manufacturer': faker.company.name(),
            'stock': faker.number.int({ min: 0, max: 100 }),
            'location': `Shelf ${faker.string.alpha(1)}${faker.number.int({ min: 1, max: 9 })}`
        });
        i++;
    }
    return sortItemsByField(parts, 'name');
}

export function createConsumables(count) {
    let consumables = [];
    let i = 0;
    while (i < count) {
        consumables.push({
            'itemNumber': `C${faker.number.int({ min: 1000, max: 9999 })}`,
            'name': faker.commerce.productName(),
            'category': faker.helpers.arrayElement(['Electrical', 'Rigging', 'Fasteners', 'Tape', 'Cleaning', 'Safety', 'Tools']),
            'stock': faker.number.int({ min: 0, max: 100 }),
            'location': `Shelf ${faker.string.alpha(1)}${faker.number.int({ min: 1, max: 9 })}`
        });
        i++;
    }
    return sortItemsByField(consumables, 'name');
}